var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-wrap"},[(!_vm.$slots.left)?_c('div',[(_vm.showReturn)?_c('i',{staticClass:"el-icon-back",on:{"click":_vm.returnLink}}):_vm._e(),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._t("left"),_vm._t("right")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }